import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import AuthServices from "../services/AuthServices";

const ProtectedRoutes = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const user = AuthServices.getToken();

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    checkAuth();
  }, [user]);

  const checkAuth = () => {
    if (user === null || user === "") {
      if (window.location.pathname !== "/admin/error404") {
        sessionStorage.setItem("nextUrl", location.pathname);
      }
      navigate("/auth/login");
    }
    setLoading(false);
  };

  if (user === null || user === "") {
    return <></>;
  }

  if (loading) {
    return (
      <div className="w-screen h-screen flex flex-row justify-center items-center">
        <Spin indicator={<LoadingOutlined style={{ color: "#666666" }} />} />
      </div>
    );
  }

  return <Outlet />;
};

export default ProtectedRoutes;
